export default __webpack_public_path__ + "static/media/train2.acd9179b.jpg";